<template>
  <PageWrapper>
    <template v-slot:content>
      <el-form :inline="false" ref="formRef" :model="form" class="company-info_form" label-width="80px">
        <el-form-item label="合同编号" prop="orderid">
          <el-input placeholder="请输入合同编号" v-model="form.orderid" />
        </el-form-item>
        <el-form-item label="客户名称" prop="company">
          <el-input placeholder="请输入客户名称" v-model="form.company" />
        </el-form-item>
        <el-form-item label="联系人" prop="name">
          <el-input placeholder="请输入联系人" v-model="form.name" clearable>
            <el-button slot="prepend" @click.native="showContacts = true">请选择联系人</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input placeholder="请输入联系方式" v-model.number="form.phone" clearable/>
        </el-form-item>
        <el-form-item label="运输方式" prop="">
          <el-input placeholder="请输入运输方式" v-model="form.ysfs" />
        </el-form-item>
        <el-form-item label="交货地址" prop="company">
          <el-input placeholder="请输入交货地址" v-model="form.company" />
        </el-form-item>
        <el-form-item>
          <el-table :data="modelList" border style="width: 100%; margin-bottom: 10px;">
            <el-table-column label="品牌" align="center">
              <template v-slot="scope">
                <el-input v-model="scope.row.source" placeholder="请输入品牌"/>
              </template>
            </el-table-column>

            <el-table-column label="型号" align="center">
              <template v-slot="scope">
                <el-input v-model="scope.row.xhname" placeholder="请输入型号"/>
              </template>
            </el-table-column>
            <el-table-column label="数量" align="center">
              <template v-slot="scope">
                <el-input v-model="scope.row.num" placeholder="请输入数量"/>
              </template>
            </el-table-column>

            <el-table-column label="备注" align="center">
              <template v-slot="scope">
                <el-input v-model="scope.row.bz" placeholder="请输入备注"/>
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center">
              <template v-slot="scope">
                <el-button type="danger" size="small" @click="handleRemove(scope.$index)" class="el-icon-delete">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleReset">重 置</el-button>
        <el-button type="primary" @click="handleSubmit">生 成</el-button>
      </div>
      <el-dialog
        v-if="showContacts"
        :visible.sync="showContacts"
        title="选择联系人"
        :width="getIsMobile?'100%':'70%'"
        :append-to-body="true"
      >
        <Contacts @childContact="getChildContact" :contract-id="id" ref="contactsRef" />
      </el-dialog>
    </template>
  </PageWrapper>
</template>
<script>
import { defineComponent, reactive, ref,watch } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue'
import Contacts from '@/components/Contacts/contacts.vue'
import request from '@/utils/request'
import {getToken } from '@/utils/auth'
import useRootSetting from '@/hooks/useRootSetting'

export default defineComponent({
  name: 'CompanyInfo',
  components: { Contacts, PageWrapper },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    id: {
      type: [Number,String],
      default: ''
    }
  },
  setup(props,{emit}) {
    const { getIsMobile } = useRootSetting()
    const formRef = ref(null)
    const defaultForm = () =>({
      orderid: '',
      company: '',
      name:'',
      phone:'',
      ysfs:'快递',
    })
    const form = reactive(defaultForm())

    const modelList = ref([
      { source: '', xhname: '', num: '', bz: '' }
    ])


    const showContacts = ref(false)
    const contactsRef = ref(null)

    const handleRemove = (index) => {
      modelList.value.splice(index, 1)
    }

    const handleSubmit = () => {
      const token = getToken()
      request({
        url: 'print_outbound.yy',
        method: 'post',
        data: {
          token: getToken(),
          id: props.data.id,
          orderid: form.orderid,
          company: form.company,
          name: form.name,
          phone: form.phone,
          ysfs: form.ysfs,
          childdata: modelList.value
        }
      }).then(res => {
        if(res.code == 200) {
          window.open(`${res.url}&token=${token}`)
        }
      })
    }


    const getChildContact = ({ name,phone }) => {
      showContacts.value = false
      form.name = name
      form.phone = phone
    }

    watch(()=>props.data,(data)=>{
      if(data){
        form.orderid = data.orderid
        form.company = data.company
        modelList.value = JSON.parse(JSON.stringify(data.childdata))
        form.name = data.name ? data.name : ''
        form.phone = data.phone ? data.phone : ''
      }
    },{immediate:true,deep:true})


    // 定义一个清空数据的方法
    const clearTable = () => {
      modelList.value.forEach(row => {
        Object.keys(row).forEach(key => {
          row[key] = '' // 清空每一项的值
        })
      })
    }

    const handleReset = () => {
        Object.assign(form,defaultForm())
        clearTable()
    }
    return {
      getIsMobile,
      contactsRef,
      showContacts,
      modelList,
      formRef,
      form,
      handleReset,
      getChildContact,
      handleRemove,
      handleSubmit,
    }
  }
})
</script>

<style scoped>
.dialog-footer {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
</style>
